import { useTheme } from "styled-components";

import { useAppSelector } from "@sso/hooks/useRedux";
import { selectCurrentUser } from "@sso/store/slices/auth";
import { Flex } from "@sso/ui/FlexBox";

const circleSize = "35px";

export const HeaderProfilePicture = () => {
  const theme = useTheme();
  const user = useAppSelector(selectCurrentUser);

  const initial = user ? (user?.firstname.charAt(0) + user?.lastname.charAt(0)).toUpperCase() : "NA";

  return (
    <Flex
      overflow="hidden"
      margin="0 0.3rem"
      borderRadius="50%"
      bgPosition="center"
      bgSize="cover"
      minWidth={circleSize}
      height={circleSize}
      width={circleSize}
      bgImage={user?.picture}
      bgColor={theme.colors.grey[300]}
      border={`1px solid ${theme.colors.grey[500]}`}
    >
      {!user?.picture && initial}
    </Flex>
  );
};
